export const REPORT_KEYS = {
  MILEAGE: 'mileage',
  LOCATION: 'location',
  PORTFOLIO_HEARTBEAT: 'portfolio-heartbeat',
  FLEET_HEARTBEAT_TRENDS: 'fleet-heartbeat-trends',
  MILES_BY_ZIP: 'miles-by-zip',
  NB_MILES_BY_ZIP: 'nb-miles-by-zip',
  NB_FLEET_RADIUS: 'nb-fleet-radius',
  FLEET_RADIUS: 'fleet-radius',
  UBI_SUMMARY: 'ubi-summary', // console-embedded; carrier-detail (insurer) tab + carrier Fleet Reporting tab
  SAFETY_EVENTS: 'safety-events',
  RISK_DECILE: 'risk-decile',
  FLEETFILE: 'fleetfile', // console-embedded; FleetFile page > FleetFile Score tab (insurer only)
} as const

export type ReportKey = typeof REPORT_KEYS[keyof typeof REPORT_KEYS]

export const REPORTING_FLAG_PREFIX = 'reporting.'
// Per-company paid features from company_config, merged into the same flag map.
export const ENTITLEMENT_FLAGS = {
  FLEET_FILE_UI: 'entitlement.fleet-file-ui',
  FLEET_FILE_API: 'entitlement.fleet-file-api',
  TRIPS_DETAILED: 'entitlement.trips-detailed',
} as const
const REPORTING_FLAG_SUFFIX = '.use-console'

/** Kill switch for the Carrier Lookback control. Shares the reporting prefix, so no second request. */
export const CARRIER_LOOKBACK_FLAG = `${REPORTING_FLAG_PREFIX}carrier-lookback.enabled`

/** No connection of the carrier has a provider that exposes either retrieval API. */
export const NO_PROVIDER_SUPPORT = 'NO_PROVIDER_SUPPORT'

/** No connection of the carrier has Is_Active = 1: there is nothing to retrieve from. */
export const CARRIER_NOT_ACTIVE = 'CARRIER_NOT_ACTIVE'

/** Reasons the control is hidden outright rather than shown disabled. */
export const LOOKBACK_HIDDEN_REASONS = [NO_PROVIDER_SUPPORT, CARRIER_NOT_ACTIVE]

export const getReportFlagKey = (reportKey: ReportKey): string =>
  `${REPORTING_FLAG_PREFIX}${reportKey}${REPORTING_FLAG_SUFFIX}`
